export const featureFlagsConstants = {
    GET_REQUEST: 'FEATUREFLAGS_GET_REQUEST',
    GET_SUCCESS: 'FEATUREFLAGS_GET_SUCCESS',
    GET_FAILURE: 'FEATUREFLAGS_GET_FAILURE',
}
